var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('b-img',{attrs:{"fluid":"","src":require("@/assets/images/logo/logo.gif"),"alt":"Login V2","width":_vm.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }